import React, { ReactNode } from 'react';
import { BoxProps } from '@material-ui/core';
import Box from '@material-ui/core/Box';

interface AppLayoutProps extends BoxProps {
  darkMode?: boolean;
  hasFooter?: boolean;
  children: ReactNode;
}

const AppLayout: React.FC<AppLayoutProps> = ({ children, style, ...rest }: AppLayoutProps) => {
  return (
    <Box
      width={{ lg: '100%' }}
      marginX={{ lg: 'auto' }}
      height="100%"
      style={{
        marginBottom: -68,
        marginTop: 0,
        backgroundColor: '#F6F4F4',
        ...style,
      }}
      {...rest}
    >
      {children}
    </Box>
  );
};

export default AppLayout;
